const storageKey = {
  IS_LOGGED: `@CircularUFRN/isLogged`,
  TMP_EMAIL: `@CircularUFRN/tmpEmail`,
  FCM_TOKEN: `@CircularUFRN/fcmToken`,
  SHOW_ERROR: `@CircularUFRN/showError`,
  SHOW_LOG: `@CircularUFRN/showLog`,

  DEVICE_CUSTOM_ID: `@CircularUFRN/deviceCustomId`,

  FCM_TOPICS_LAST_ACTIVE: "@CircularUFRN/FCMTopicsLastActive",

  FAVORITE_STOP: `@CircularUFRN/favoriteStop`,

  SUBSCRIBED_TO_MAIN: `@CircularUFRN/subscribedToMain`,
  MAIN_NOTIFICATION_CHANNEL: `defaultChannel`,

  LAST_CLEAR_INDEXDB: "@CircularUFRN/LastClearIndexDB",

  CACHE_NAME: "@CircularUFRN/V1Chache",
  CHANNEL_NAME: "@CircularUFRN/SWMessage",
  ENABLE_CHANNEL: false,
  CACHE_SHARE_KEY: "/shareFile/temp",
  PUSH_VAPID_KET: "",
  DISABLE_BOTTOM_PAD: "@CircularUFRN/BottomPadding",
  DIMISSED_BANNERS: "@CircularUFRN/DimissedBanners",

  LAST_UPDATE_DIMISS: "@CircularUFRN/LastUpdateDimiss",

  RATING_VERSION: "@CircularUFRN/RatingVersion",

  CRASH_COUNT: "@CircularUFRN/CrashCount",

  CUSTOM_CACHE: {
    RU_MENU: "@CircularUFRN/Cache/RuMenu",
  },
};

export default storageKey;
